// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Project_wrap__1WMpz","preImg":"Project_preImg__2SUn9","imgWrap":"Project_imgWrap__2_hZE"};